import { createContext } from "react";

import type { FieldErrors } from "./workspace";
export const FormValidation = createContext<{
	errors: FieldErrors;
	id: string;
	integration?: boolean;
}>({ errors: {}, id: "form" });
